import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import BackButton from '@/components/BackButton/BackButton';
import styles from './ErrorTemplate.module.scss';
export default function ErrorTemplate(t0) {
  const $ = _c(11);
  const {
    title,
    description
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image src="/cc/image/logo_error.svg" alt="Error" width={150} height={150} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <h1>{title}</h1>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== description) {
    t3 = <p>{description}</p>;
    $[3] = description;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className={styles.textContent}>{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <BackButton type="text" text={"\uC774\uC804\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30"} />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <main className={styles.main}><section className={styles.errorTemplate}><div className={styles.container}>{t1}<div className={styles.content}>{t4}{t5}</div></div></section></main>;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}